module.exports = __webpack_public_path__ + "img/paywall.89f116fa.svg";